import classnames from 'classnames';
import * as React from 'react';

import { IProjectFilter } from '../../../../models';

import './index.scss';

interface IProps {
    filters: IProjectFilter[];
    onActiveFilterChange: (activeFilter: IProjectFilter | null) => void;
}

export const FilterTabs: React.SFC<IProps> = ({ filters, onActiveFilterChange }) => {
    const [isFilterOpen, setFilterOpen] = React.useState(false);
    const [activeFilter, setActiveFilter] = React.useState<IProjectFilter | null>(null);
    const handleFilterChange = React.useCallback(
        (filter: IProjectFilter | null) => {
            onActiveFilterChange(filter);
            setActiveFilter(filter);
        },
        [onActiveFilterChange]
    );

    return (
        <div className={classnames('filter-tabs', { 'is-open': isFilterOpen })} >
            <div className="label" onClick={() => setFilterOpen(!isFilterOpen)}>
                Filter
                <div className="arrow-filter">
                    <svg xmlns="http://www.w3.org/2000/svg" width="30.594" height="22.707" viewBox="0 0 30.594 22.707">
                        <g id="Group_102" data-name="Group 102" transform="translate(155.354 204.354) rotate(180)">
                            <g id="Group_101" data-name="Group 101">
                                <line id="bottom" data-name="Line 9" x2="10" y2="10" transform="translate(145 182)" fill="none" stroke="#272727" strokeWidth="1" />
                                <line id="top" data-name="Line 10" x1="10" y2="10" transform="translate(145 194)" fill="none" stroke="#272727" strokeWidth="1" />
                            </g>
                            <line id="Line_11" data-name="Line 11" x2="23.979" transform="translate(124.76 193.006)" fill="none" stroke="#272727" strokeWidth="1" />
                        </g>
                    </svg>
                </div>
            </div>
            {
                isFilterOpen &&
                (
                    <div className="filter-list">
                        <ul>
                            <li
                                className={classnames({ active: activeFilter === null })}
                                onClick={() => handleFilterChange(null)}
                            >
                                <span>All</span>
                            </li>
                            {filters && filters.map((filter) => (
                                <li
                                    key={filter.id}
                                    className={classnames({ active: filter.id === (activeFilter && activeFilter.id) })}
                                    onClick={() => handleFilterChange(filter)}
                                >
                                    <span>{filter.name}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                )
            }
        </div>
    );
};
